import * as React from 'react';

import {Button} from '../button/button';
import {PopoverInfo} from '../popover-info/popover-info';

import styles from './modal-header-breadcrumbs.module.css';

export type ModalHeaderBreadcrumb = {
    text: string;
    helpInfo?: React.ReactNode;
    onClick?: () => void;
};

type Props = {
    breadcrumbs: ModalHeaderBreadcrumb[];
};

export function ModalHeaderBreadcrumbs(props: Props) {
    const isBreadcrumb = (index: number) => {
        return index < props.breadcrumbs.length - 1;
    };

    const renderBreadcrumb = (breadcrumb: ModalHeaderBreadcrumb) => (
        <div className='flex align-center'>
            <Button
                variant='text-secondary'
                size='big'
                onClick={breadcrumb.onClick}
                noPadding={true}
            >
                <p className={styles['title--breadcrumb']}>{breadcrumb.text}</p>
            </Button>
            {breadcrumb.helpInfo ? <PopoverInfo size={17} info={breadcrumb.helpInfo} /> : undefined}
            <span className={styles.arrow}>&gt;</span>
        </div>
    );

    const renderTitle = (breadcrumb: ModalHeaderBreadcrumb) => (
        <div className={styles.title}>{breadcrumb.text}</div>
    );

    return (
        <div className='flex align-center'>
            {props.breadcrumbs.map((breadcrumb, index) => (
                <div key={breadcrumb.text}>
                    {isBreadcrumb(index) ? renderBreadcrumb(breadcrumb) : renderTitle(breadcrumb)}
                </div>
            ))}
        </div>
    );
}
